import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Button } from '../common';
import heroImage from '../../assets/hero_image.jpg';
import heroImageWebp from '../../assets/hero_image.webp';

const HeroSection = styled.section`
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  color: white;
`;

const HeroPicture = styled.picture`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;

    @media (max-width: 768px) {
      object-position: 75% center;
    }
  }
`;

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5));
  z-index: 1;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1200px;
  padding: 0 20px;
  text-align: center;
`;

const HeroTitle = styled(motion.h1)`
  font-size: 3.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled(motion.p)`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ServiceMode = styled(motion.p)`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  opacity: 0.8;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

export const Home = () => {
  // Function to handle agenda button click
  const handleAgendaClick = () => {
    const event = new CustomEvent('openAgendaModal');
    window.dispatchEvent(event);
  };

  return (
    <>
      <HeroSection id="inicio">
        <HeroPicture>
          <source srcSet={heroImageWebp} type="image/webp" />
          <img
            src={heroImage}
            alt="Consultorio de Psicóloga Andrea Dávila en Pocitos, Montevideo"
            width="4032"
            height="2268"
            fetchpriority="high"
            decoding="sync"
          />
        </HeroPicture>
        <HeroOverlay />
        <ContentWrapper>
          <HeroTitle
            initial="hidden"
            animate="visible"
            variants={fadeIn}
          >
            Terapia Psicológica
          </HeroTitle>
          <HeroSubtitle
            initial="hidden"
            animate="visible"
            variants={fadeIn}
          >
            Psicóloga especializada en terapia cognitivo-conductual y EMDR
          </HeroSubtitle>
          <ServiceMode
            initial="hidden"
            animate="visible"
            variants={fadeIn}
          >
            Atención online y presencial
          </ServiceMode>
          <Button
            size="large"
            icon="fa-regular fa-calendar"
            onClick={handleAgendaClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Agendar Consulta
          </Button>
        </ContentWrapper>
      </HeroSection>
    </>
  );
};
